import "../styles/genai.css";
import dataHeroImg from "../assets/data-hero.png";

export default function DataAnalyticsHero() {
  return (
    <section className="genai-hero full-hero data-hero">
      {/* OVERLAY */}
      <div className="hero-overlay"></div>

      {/* CONTENT */}
      <div className="hero-content">
        <h1 className="hero-title">
          DATA ANALYTICS – MASTER CORE ESSENTIALS
        </h1>

        <p className="hero-desc">
          Learn to Analyze Data & Turn Insights into Business Decisions
        </p>
      </div>
    </section>
  );
}
